<script>
    import LyHeadline from '../../../layouts/components/LyHeadline.svelte';
    import LyHeader from '../../../layouts/components/LyHeader.svelte';
    import LyButton from '../../../layouts/forms/LyButton.svelte';
    import { UserStore } from '../../../stores/UserStore.svelte.js';
    import { onMount } from 'svelte';
    import { AiAnnouncementStore } from './AiAnnouncementStore.svelte.js';
    import { UsersStore } from '../../../stores/UsersStore.svelte.js';
    import LyContent from '../../../layouts/components/LyContent.svelte';
    import LyP from '../../../layouts/components/LyP.svelte';
    import LyTableHeadCol from '../../../layouts/tables/LyTableHeadCol.svelte';
    import LyTableHead from '../../../layouts/tables/LyTableHead.svelte';
    import LyTable from '../../../layouts/tables/LyTable.svelte';
    import LyTableHeadRow from '../../../layouts/tables/LyTableHeadRow.svelte';
    import LyTableBody from '../../../layouts/tables/LyTableBody.svelte';
    import LyUser from '../../../layouts/users/LyUser.svelte';
    import LyTableBodyRow from '../../../layouts/tables/LyTableBodyRow.svelte';
    import LyTableBodyCol from '../../../layouts/tables/LyTableBodyCol.svelte';
    import * as Icons from 'lucide-svelte';
    import LyButtonLine from '../../../layouts/forms/LyButtonLine.svelte';

    /**
     * @type {{
     *      backButton?: () => void,
     * }}
     */
    let { backButton = () => {} } = $props();

    // -
    let isAdmin = $state(UserStore.hasGroup('AI'));
    let mounting = $state(true);

    onMount(() => {
        UsersStore.reset();
        AiAnnouncementStore.reset();
        mounting = false;
    });

    // -
    const announcementStats = $derived(AiAnnouncementStore.getUserStatistics());
</script>

{#if isAdmin}
    <LyHeader>
        <LyHeadline weight={2}>Benutzer-Übersicht</LyHeadline>
    </LyHeader>

    <LyButtonLine mb={true}>
        <LyButton label="Zurück" color={true} onclick={backButton} />
    </LyButtonLine>

    {#if mounting && (UsersStore.isLoading || AiAnnouncementStore.isLoading)}
        <LyContent>
            <LyP><em>Benutzer werden geladen&hellip;</em></LyP>
        </LyContent>
    {:else if UsersStore.users.length === 0}
        <LyContent>
            <LyP><em>Keine Benutzer gefunden&hellip;</em></LyP>
        </LyContent>
    {:else}
        <LyTable wrapper={true}>
            <LyTableHead>
                <LyTableHeadRow>
                    <LyTableHeadCol>Benutzer</LyTableHeadCol>
                    <LyTableHeadCol>Anzahl Bogen</LyTableHeadCol>
                    <LyTableHeadCol>High-Risk</LyTableHeadCol>
                </LyTableHeadRow>
            </LyTableHead>
            <LyTableBody>
                {#each UsersStore.users as user}
                    {@const stat = announcementStats.find((item) => item.userId === user.userId)}
                    <LyTableBodyRow>
                        <LyTableBodyCol>
                            <LyUser user_id={user.userId} />
                        </LyTableBodyCol>
                        <LyTableBodyCol>
                            {#if (stat?.count ?? 0) > 0}
                                <span class="font-mono">{stat?.count ?? 0}</span>
                            {:else}
                                <Icons.CircleX class="text-error-500" />
                            {/if}
                        </LyTableBodyCol>

                        <LyTableBodyCol>
                            <div class="flex items-center gap-2">
                                {#if stat?.highestRisk === 'prohibited'}
                                    <Icons.OctagonX class="text-error-500" />
                                {:else if stat?.highestRisk === 'high-risk'}
                                    <Icons.TriangleAlert class="text-warning-500" />
                                {/if}

                                {#if stat?.hasUnknown}
                                    <Icons.ShieldQuestionMark class="text-unknown-500" />
                                {/if}
                            </div>
                        </LyTableBodyCol>
                    </LyTableBodyRow>
                {/each}
            </LyTableBody>
        </LyTable>
    {/if}

    <LyButtonLine mt={true}>
        <LyButton label="Zurück" color={true} onclick={backButton} />
    </LyButtonLine>
{/if}
